import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatomoTracker } from 'ngx-matomo';
import { GetDataService } from '../services/get-data.service';

@Component({
  selector: 'app-impuls',
  templateUrl: './impuls.component.html',
  styleUrls: ['./impuls.component.scss']
})
export class ImpulsComponent implements OnInit {

  myId = null;
  tag = null;
  text = null;
  audio = null;

  constructor(
    public getDataService: GetDataService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private matomoTracker: MatomoTracker) {
    if (typeof this.router.getCurrentNavigation().extras.state != 'undefined') {
      // Tag vorhanden
      // Infos zum Tag abholen
      this.tag = this.router.getCurrentNavigation().extras.state.tag;

      // Text anfordern
      this.http.get('assets/' + this.tag.id + '.html', { responseType: 'text' }).subscribe(
        resData => {
          this.text = resData;
        }
      )

    } else {
      //Tag nicht vorhanden
      // Türchen nicht vorhanden
    }
  }

  ngOnInit(): void {
    this.matomoTracker.setDocumentTitle(this.tag.name);
    this.matomoTracker.setCustomUrl(this.router.url);
    this.matomoTracker.trackPageView();
  }
}
